import find from 'lodash/find'
import type { AnyPresentationOption, PresentationOption, PresentationOptionV2 } from 'paintscout'

/**
 * Looks up a presentation key across the v1 and v2 libraries, preferring v1 — matches
 * isPresentationNext()'s tie-break for a key that exists in both.
 */
export function findPresentationOption(args: {
  key: string
  v1: PresentationOption[]
  v2?: PresentationOptionV2[]
}): AnyPresentationOption | undefined {
  const { key, v1, v2 = [] } = args
  return find(v1, { key }) || find(v2, { key })
}
